import { InAppMessageClickEvent, OneSignal } from 'react-native-onesignal';
import { isWeb } from '../../config/designSystem/Layout';


export const setIAMClickHandler = (cb: (data: string) => void) => {
  if(!isWeb) {
    const listener = (event: InAppMessageClickEvent) => {
      const value = event.result.actionId;
      if(value) {
        cb(value);
      }
    };
    OneSignal.InAppMessages.addEventListener('click',listener);
    return listener;
  }
};

export const removeIAMClickHandler = (listener: ((event: InAppMessageClickEvent) => void) | undefined) => {
  if(!isWeb && !!listener) {
    OneSignal.InAppMessages.removeEventListener('click',listener);
  }
};